import { ReactElement } from 'react';
import { Link, useHistory } from 'react-router-dom';

import Storage from 'lib/Storage';

type Menu = {
  icon: string;
  name: string;
  link: string;
};

function AuthorLayoutSidebar(): ReactElement<HTMLElement> {
  let history = useHistory();
  let storage = new Storage();
  let menus: Menu[] = [
    {
      icon: 'https://res.cloudinary.com/trycatch/image/upload/v1628413086/thexdev/icons/ui_icon_rocket_zzbvyb.svg',
      name: 'Dashboard',
      link: '/a/dashboard',
    },
    {
      icon: 'https://res.cloudinary.com/trycatch/image/upload/v1628413086/thexdev/icons/ui_icon_unread_dlxais.svg',
      name: 'Inbox',
      link: '/a/inbox',
    },
  ];

  // Exit.
  function exit() {
    storage.reset();
    history.push('/enter');
  }

  return (
    <aside className="mr-5 w-1/5 grid grid-cols-2">
      {menus.map((menu) => (
        <div key={menu.name}>
          <Link className="block" key={menu.name} to={menu.link}>
            <div className="mx-auto w-12 h-12 mb-2 p-3 rounded-xl bg-gray-200">
              <img
                className="mx-auto"
                src={menu.icon}
                width={28}
                height={28}
                alt={menu.name}
              />
            </div>
            <p className="text-center text-sm font-body">{menu.name}</p>
          </Link>
        </div>
      ))}
      <button
        className="h-10 rounded-xl col-span-2 bg-secondary text-sm text-white font-display"
        onClick={exit}
      >
        EXIT
      </button>
    </aside>
  );
}

export default AuthorLayoutSidebar;
